import { DefaultQueryParams } from '@frontend/api-utils';
import { ChartClient } from '@frontend/chart/api';
import { VendingPackageVolumeByUserListChart } from '@frontend/chart/components';
import { Chart, ChartQueryParam } from '@frontend/chart/types';
import { useEffect, useState } from 'react';

import { getLast30DaysChartRange } from '../../pudo/last-30-days-chart-range';
import { Last30DaysVendingPackageVolumeByUserListChartProps } from './last-30-days-vending-package-volume-by-user-list-chart.component';

export const useLast30DaysVendingPackageVolumeByUserListChart = (props: Last30DaysVendingPackageVolumeByUserListChartProps) => {
    const [data, setData] = useState<Chart | undefined>(undefined);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        if (!props.accountId) {
            setIsLoading(false);
            return;
        }

        let cancelled = false;
        setIsLoading(true);

        const { after, before } = getLast30DaysChartRange();

        ChartClient.fetchChartData(props.accountId, VendingPackageVolumeByUserListChart.definition, {
            [DefaultQueryParams.AFTER]: after,
            [DefaultQueryParams.BEFORE]: before,
            [ChartQueryParam.SORT_DIRECTION]: 'desc'
        })
            .then((chart) => {
                if (!cancelled) {
                    setData(chart);
                }
            })
            .catch(() => {
                if (!cancelled) {
                    setData(undefined);
                }
            })
            .finally(() => {
                if (!cancelled) {
                    setIsLoading(false);
                }
            });

        return () => {
            cancelled = true;
        };
    }, [props.accountId]);

    return { data, isLoading };
};
